import { ReactElement, useState } from 'react';
import { Text } from '@keyslabor/shared/ui';
import useModal from '@keyslabor/shared/hooks/useModal';
import ModalConfirm from '@/components/ModalConfirm';
import { ModalConfirmExtProps } from '@/components/ModalConfirm/types';
import { useDeleteLostHoursMutation } from '@/api/methods/useDeleteLostHoursMutation.ts';

export default function useDelete() {
  const [curId, setCurId] = useState<number | undefined>(undefined);

  const { mutateAsync: deleteLostHours } = useDeleteLostHoursMutation();

  const props: ModalConfirmExtProps = {
    callback: () => deleteLostHours({ id: curId }),
    textOk: 'Confirm',
    textSuccessOk: 'OK',
    textClose: 'Cancel',
    titleSuccess: 'Lost Hours deleted',
    children: (
      <Text fontSize="16px" fontWeight="700">
        Are you sure you want to delete?
      </Text>
    ),
  };

  const { modalProps, onToggle } = useModal();

  return [
    <ModalConfirm key="delete-lost-hour-item" {...props} {...modalProps} />,
    (id: number) => {
      setCurId(id);
      onToggle();
    },
  ] as [ReactElement, (id: number) => void];
}
